//*** Import React Library
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Table from "react-data-table-component";
import Button from "react-bootstrap/Button";
import Axios from 'axios'
import "../../Assets/Styles/robot.css";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
import AxiosInstance from '../Axios/AxiosInstance';
///*** Global Variables 
var PlantID =null;
//***End Global Variables
//let _plantID = (new URLSearchParams(window.location.search)).get("pid")
//PlantID = _plantID;
const columns = [
    { name: "Sr. No.", selector: (row) => row.id +1, sortable: true },
    { name: "Robot Name", selector: (row) => row.robotName, sortable: true },
    { name: "User Name", selector: (row) => row.userName, sortable: true },
    { name: "Broadcast Status", selector: (row) => row.broadcastStatus, sortable: true },
    { name: "Date and Time (HH:MM:SS)", selector: (row) => row.broadcastDate, sortable: true, }
];
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
            /*  fontSize: "100%"*/
        },
    },
    headRow: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};
export const PlantRobotsBroadcastStatus = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([])
    const [List, setList] = useState([])
    const [SelectedList, setSelectedList] = useState([])
    const [MasterChecked, setMasterChecked] = useState(false)
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = data;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setList(filteredData);
        }
        if (event.target.value === "") {
            setList(data);
        }
    };
    const filteredData = List.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    const handleRowSelected = (rows) => {
        setData(rows.selectedRows);
    };
    //const contextActions = (
    //    <button onClick={() => alert(data.map((r) => r.robotID))}>
    //        Show Selected Rows
    //    </button>
    //);
    useEffect(() => {
        fetchData();
    }, [])
    useEffect(() => {
        console.log(data)
    }, [data])
    const fetchData = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        //alert(plant_id);
        //const response = await Axios("/PlantRobotsBroadcastStatus?pid=" + plant_id + "&rt='AllDate'");
        try { 
            //alert("ok");
            const response = await AxiosInstance.get("/PlantRobotsBroadcastStatus?pid=" + plant_id + "&rt='AllDate'");
            setData(response.data)
            setList(response.data)
            //alert("ok1");
            //if (response && typeof response.then === 'function') {
                //response.then((res) => {
                //    if (res.data) {
                //        setData(response.data)
                //        setList(response.data)
                //    }
                //})
                //response.catch(
                //    function (error) {
                //        // Error Object Properties
                //        // 1. error.message: The error message.
                //        //2. error.response: The response object(if available).
                //        //3. error.request: The request object(if available).
                //        //4. error.config: The Axios request configuration.

                //        //Handling Different Error Types
                //        //1. Network errors: Check error.request to handle network - related issues.
                //        //2. Server errors: Check error.response to handle server - side errors(e.g., 404, 500).
                //        //3. Timeout errors: Check error.code to handle timeout - related issues.

                //        if (error.response) {
                //            // Server responded with an error
                //            ////Server Error Codes
                //                // 1. 400 Bad Request: The request was invalid or cannot be processed.
                //                //2. 401 Unauthorized: Authentication is required or failed.
                //                //3. 403 Forbidden: Access to the resource is forbidden.
                //                //4. 404 Not Found: The requested resource was not found.
                //                //5. 500 Internal Server Error: A generic server error occurred.
                //                //6. 502 Bad Gateway: The server received an invalid response from an upstream server.
                //                //7. 503 Service Unavailable: The server is currently unavailable.

                //            console.error(`Server error: ${error.response.status}`);
                //        } else if (error.request) {
                //            /// Network error
                //                //1. Timeouts: When a request takes too long to complete.
                //                //2. Connection refused: When the server refuses the connection.
                //                //3. No internet connection: When the client lacks internet connectivity.
                //                //4. DNS resolution failures: When the domain name cannot be resolved.
                //                //5. Server unreachable: When the server is down or unreachable.
                //        ////Network Error Codes
                //            //1. ENOTFOUND: DNS lookup failed(domain not found).
                //            //2. ECONNREFUSED: Connection refused by the server.
                //            //3. ETIMEDOUT: Connection timed out.
                //            //4. ECONNABORTED: Connection aborted(often due to timeout).
                //            //5. ENETUNREACH: Network is unreachable.

                //            console.error('Network error:', error.message);
                //            // Retry request or provide user feedback
                //        } 
                //          else if (error.code === 'ECONNABORTED') {
                //            console.error('Connection aborted due to timeout or network issue');
                //            // Retry request or provide user feedback
                //        }
                //        else {
                //            // Other errors
                //            console.error(error.message);
                //        }

                //        console.log('Error Message:' + error)
                //    }
                //)
            //}
            //else {
            //    console.log("Response is not a promise");
            //}
        }
        catch (error) {
            console.log('Error Message:' + error)
        }
    }
    return (
        <>
         {hasJWTToken() ? (
             <div>
                <h3 style={{ margin: "2%", marginLeft:"2%" }}>Plant Robots Connected Status</h3>
                <div
                style={{
                    border: "1px solid #c0c0c0",
                    borderRadius: "5px",
                    margin: "2%",
                    backgroundColor: "#fff",
                }}
            >
                <div className="container dvscroll" style={{ width: "100%", height: "70%", fontSize: "92%" }} >
                    <div className="row dvscroll">
                        <div className="col-sm-12">
                            <input
                                type="text"
                                placeholder="Search Results"
                                style={{
                                    width: "20%",
                                    height: "30px",
                                    margin: "10px",
                                    float: "right",
                                    border: "none",
                                    padding: "1.5%",
                                    borderRadius: "5px",
                                }}
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                            <p></p>
                            <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
                                search={true}
                                columns={columns}
                                data={filteredData}
                                highlightOnHover={true}
                                customStyles={customStyles}
                            >
                            </DataTable>
                        </div>
                    </div>
                </div>
                </div>
             </div>
            ) :
                (
                    <Route to={{ pathname: '#/login' }} />
                )
            }

        </>
    );
};
